import { render } from "./add-department.vue?vue&type=template&id=1f3f3340"
import script from "./add-department.vue?vue&type=script&lang=js"
export * from "./add-department.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__